import { useQuery } from '@tanstack/react-query'

import { getFilterOptions } from '../apartments'
import type { ListingType } from '../types'
import { livabilityKeys } from './keys'

export function useApartmentFilterOptions(listingType: ListingType = 'rent') {
  return useQuery({
    queryKey: livabilityKeys.filterOptions(listingType),
    queryFn: () => getFilterOptions(listingType),
    // Metadata changes when ingestion runs; avoid serving pre-fix empty districts for 30 min.
    staleTime: 1000 * 60 * 2,
    refetchOnMount: true
  })
}
